export class JWTTokenResponse {
  token: string;
  success: boolean;
  permissions: Permission[];
  userType?: number;
  constructor() {
    this.token = "";
    this.success = true;
    this.permissions = [];
  }
}

export interface Permission {
  securityCode: string;
  permission: PermissionType;
}

export enum PermissionType {
  Edit = 1,    // Full access (create, read, update, delete)
  View = 2,    // Read-only access
  Deny = 4     // No access
}

// Helper function to check if a permission allows editing
export function hasEditPermission(permission: Permission): boolean {
  return permission.permission === PermissionType.Edit;
}

// Helper function to check if a permission allows viewing
export function hasViewPermission(permission: Permission): boolean {
  return permission.permission === PermissionType.View || permission.permission === PermissionType.Edit;
}
